// extracted by mini-css-extract-plugin
export default {"buttonsBox":"ConfirmationModal_buttonsBox__xDrfT"};